export default __webpack_public_path__ + "static/media/order_4.bca70183.png";